<template>
  <div class="row justify-content-center m-0 mt-5">
      <div class="col-xl-7 text-center mt-5">
        <hr :class="color">
        <h2 v-html="titulo"></h2>
        <div class="row justify-content-center">
            <div class="col-xl-9">
                <div class="idea" v-if="idea">{{ idea }}</div>
            </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'Titulo',
  props: {
    titulo: String,
    idea: String,
    color: {
        type: String,
        default: 'azul',
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h2 {
  font-weight: 300;
  font-size: 30px;
}
.idea {
    margin: 40px 0 60px 0;
    font-weight: 300;
}
hr {
    width: 40px;
    text-align:left;
    margin-top: 0;
    margin-bottom: 30px;
}
.azul {
    border: 3px solid #00C4FF;
}
.morado {
    border: 3px solid #1700FF;
}
</style>
